export default __webpack_public_path__ + "static/media/superunion-logo-dark.95198896.svg";